import React from 'react';

export default function HTML_Tag_List() {
  return (
    <div className="HTML_Tag_List">
      <h1>HTML Tag List</h1>
      <p>This is the placeholder component for <strong>HTML Tag List</strong>.</p>
      <p>Link: /html/reference/tag-list</p>
    </div>
  );
}
